<template lang="pug">
  el-form(
    :model="form"
    :rules="rules"
    ref="form"
    label-width="150px"
  )

    title-bar(style="margin-bottom: 20px") {{ $t('① 公司信息') }}

    el-form-item(:label="$t('供应商中文名称')" prop="vendor_name_ch")
      el-input(v-model="form.vendor_name_ch" :disabled="true")

    el-form-item(:label="$t('供应商英文简称')" prop="vendor_name")
      el-input(v-model="form.vendor_name" :disabled="true")

    el-form-item(:label="$t('是否为总库供应商')" prop="is_total_vendor")
      el-radio(v-model="form.is_total_vendor" :label="1" :disabled="true") {{ $t('是') }}
      el-radio(v-model="form.is_total_vendor" :label="0" :disabled="true") {{ $t('否') }}

    el-form-item(v-if="form.is_total_vendor === 1" :label="$t('供应商ID')" prop="vendor_internal_id")
      el-input(v-model="form.vendor_internal_id" :disabled="true")

    el-form-item(:label="$t('官方网站')")
      el-input(v-model="form.website_url" :maxlength="100")

    el-form-item(:label="$t('官方Logo')" prop="company_logo_url")
      .upload-area
        el-upload(
          class="uploader"
          action="-"
          :http-request="upload(logoUploadSuccess)"
          :show-file-list="false"
          :before-upload="onBeforeUpload"
        )
          img(v-if="form.company_logo_url" :src="logoPath" class="avatar")
          template(v-else)
            i(class="el-icon-plus avatar-uploader-icon")
            .upload__text {{ $t('点击上传') }}

        .upload-area__title  {{ $t('微博官方账号二维码') }}
        el-upload(
          class="uploader"
          action="-"
          :http-request="upload(weiboUploadSuccess)"
          :show-file-list="false"
          :before-upload="onBeforeUpload"
        )
          img(v-if="form.weibo_qr_code" :src="weiboPath" class="avatar")
          template(v-else)
            i(class="el-icon-plus avatar-uploader-icon")
            .upload__text {{ $t('点击上传') }}

        .upload-area__title  {{ $t('微信公众号二维码') }}
        el-upload(
          class="uploader"
          action="-"
          :http-request="upload(wechatUploadSuccess)"
          :show-file-list="false"
          :before-upload="onBeforeUpload"
        )
          img(v-if="form.wechat_qr_code" :src="wechatPath" class="avatar")
          template(v-else)
            i(class="el-icon-plus avatar-uploader-icon")
            .upload__text {{ $t('点击上传') }}

    el-form-item(:label="$t('公司性质')" prop="company_type")
      el-radio(v-model="form.company_type" :label="1") {{ $t('非上市公司') }}
      el-radio(v-model="form.company_type" :label="2") {{ $t('上市公司') }}

    el-form-item(:label="$t('是否有母公司')" prop="parent_company")
      el-radio(v-model="form.parent_company" :label="0") {{ $t('否') }}
      el-radio(v-model="form.parent_company" :label="1") {{ $t('是') }}

    el-form-item(v-if="form.parent_company" :label="$t('母公司名称')" prop="parent_company_name")
      el-input(v-model="form.parent_company_name")

    el-form-item(:label="$t('公司规模')" prop="company_size")
      el-radio(v-model="form.company_size" :label="1") {{ $t('少于30人') }}
      el-radio(v-model="form.company_size" :label="2") {{ $t('30-50人') }}
      el-radio(v-model="form.company_size" :label="3") {{ $t('50-100人') }}
      el-radio(v-model="form.company_size" :label="4") {{ $t('100-300人') }}
      el-radio(v-model="form.company_size" :label="5") {{ $t('大于300人') }}

    el-form-item(:label="$t('成立时间')" prop="establish_time")
      el-date-picker(v-model="form.establish_time" type="year" placeholder="with year" value-format="yyyy")

    el-form-item(:label="$t('所在城市')" prop="city")
      el-input(v-model="form.city" :maxlength="100")

    el-form-item(:label="$t('地址')" prop="address")
      el-input(v-model="form.address")

    el-form-item(:label="$t('邮编')" prop="zip_code")
      el-input(v-model="form.zip_code")

    el-form-item(:label="$t('电话')" prop="telephone")
      el-input(v-model="form.telephone")

    el-form-item(:label="$t('公司介绍')" prop="company_introduction")
      el-input(
        v-model="form.company_introduction"
        type="textarea"
        :rows="8"
        style="width: 450px;"
        :placeholder="$t('公司介绍不多于500字')"
      )

    el-form-item(:label="$t('企业资质')")
      .qualification-list
        .qualification
          span.qualificatin__title.required {{ $t(form.qualification[0].name) }}
          el-upload(
            action="-"
            :http-request="upload(qualificationUploadSuccess, form.qualification[0])"
            :show-file-list="false"
            accept="image/gif,image/jpeg,image/jpg,image/png"
            :before-upload="onBeforeUpload"
          )
            el-button(type="primary") {{ $t('点击上传') }}
          span(v-if="!form.qualification[0].downloadPath" style="margin-left: 5px") ({{ $t('仅JPG/JPEG/PNG/GIF') }})
          a(
            :href="form.qualification[0].downloadPath"
            style="margin-left: 10px"
            target="_blank"
          ) {{ $t(form.qualification[0].fileName) }}

        .qualification(v-for="item, index in form.qualification" :key="index" v-if="index > 0")
          el-input.qualificatin__title(v-model="item.name" :placeholder="$t('填写资质名称')")
          el-upload(
            action="-"
            :http-request="upload(qualificationUploadSuccess, item)"
            :show-file-list="false"
            accept="image/gif,image/jpeg,image/jpg,image/png"
            :before-upload="onBeforeUpload"
          )
            el-button(type="primary") {{ $t('点击上传') }}
          span(v-if="!item.downloadPath" style="margin-left: 5px") ({{ $t('仅JPG/JPEG/PNG/GIF') }})
          a(
            :href="item.downloadPath"
            style="margin-left: 10px"
            target="_blank"
          ) {{ item.fileName }}
          el-button(
            icon="el-icon-delete"
            circle
            style="width: 30px; height: 30px"
            @click="deleQualification(index)"
          )

      el-button(type="text" @click="addQualification") {{ $t('+ 新增资质') }}

    el-form-item(:label="$t('供应商服务大类')")
      select-campaign-category(
        v-model="form.category"
        :showLabel="false"
        :showRoster="true"
        :roster="roster"
        :disabled="true"
        style="margin-top: -30px"
      )
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import TitleBar from '@/components/TitleBar'
import SelectCampaignCategory from '@/components/SelectCampaignCategory'

export default {
  components: {
    TitleBar,
    SelectCampaignCategory
  },
  props: {
    data: {
      type: Object
    }
  },
  data () {
    let validateIntro = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('请输入公司介绍')))
      } else if (value.length > 500) {
        callback(new Error(this.$t('公司介绍不多于500字')))
      } else {
        callback()
      }
    }
    let validateAddress = (rule, value, callback) => {
      if (value.length > 100) {
        callback(new Error(this.$t('地址不多于100字')))
      } else {
        callback()
      }
    }
    return {
      form: {
        vendor_name: '',
        vendor_name_ch: '',
        is_total_vendor: 1,
        vendor_internal_id: '',
        website_url: '',
        company_logo_url: null,
        company_logo: null,
        weibo_qr_code: null,
        wechat_qr_code: null,
        company_type: 1,
        parent_company: 0,
        parent_company_name: '',
        company_size: 1,
        establish_time: dayjs().format('YYYY'),
        city: '',
        address: '',
        zip_code: '',
        telephone: '',
        company_introduction: '',
        qualification: [
          {
            name: '营业执照',
            fileName: '',
            path: '',
            downloadPath: ''
          }
        ],
        category: []
      },
      rules: {
        vendor_name: [ { required: !this.isVendor() } ],
        vendor_name_ch: [ { required: !this.isVendor() } ],
        is_total_vendor: [ { required: !this.isVendor() } ],
        vendor_internal_id: [ { required: !this.isVendor(), message: this.$t('请输入供应商ID'), trigger: 'blur' } ],
        company_logo_url: [ { required: true, message: this.$t('请上传官方Logo') } ],
        company_type: [ { required: true } ],
        parent_company: [ { required: true } ],
        parent_company_name: [ { required: true, message: this.$t('请填写母公司名称') } ],
        company_size: [ { required: true } ],
        establish_time: [ { required: true, message: this.$t('请选择创建时间') } ],
        company_introduction: [ { required: true, trigger: 'blur', validator: validateIntro } ],
        city: [ { required: true, trigger: 'blur', message: this.$t('请输入城市') } ],
        address: [ { required: false, trigger: 'blur', validator: validateAddress } ]
      },
      logoPath: '',
      wechatPath: '',
      weiboPath: '',
      roster: [false, false, false]
    }
  },
  watch: {
    data () {
      this.form = Object.keys(this.form).reduce((pre, cur) => {
        if (this.data[cur] == null || this.data[cur].length === 0) {
          pre[cur] = this.form[cur]
          return pre
        }

        if (cur === 'qualification') {
          pre[cur] = this.data.qualification.map(item => ({
            name: item.qualification_type,
            fileName: item.file_name,
            path: item.qualification_path,
            downloadPath: item.download_url
          }))
          return pre
        }

        pre[cur] = this.data[cur]
        return pre
      }, {})
      // 判断 digital design it 是否是 roster
      const findIsRoster = id => {
        const item = this.data.category.find(i => i.category_id === id)
        return item && Boolean(item.is_storage)
      }
      this.roster = [findIsRoster(1), findIsRoster(2), findIsRoster(5)]
      this.logoPath = this.data.company_logo_url
      this.wechatPath = this.data.wechat_qr_code_url
      this.weiboPath = this.data.weibo_qr_code_url
    }
  },
  methods: {
    logoUploadSuccess (serverPath, downloadPath) {
      this.form.company_logo_url = serverPath
      this.form.company_logo = serverPath
      this.logoPath = downloadPath
    },
    weiboUploadSuccess (serverPath, downloadPath) {
      this.form.weibo_qr_code = serverPath
      this.weiboPath = downloadPath
    },
    wechatUploadSuccess (serverPath, downloadPath) {
      this.form.wechat_qr_code = serverPath
      this.wechatPath = downloadPath
    },
    qualificationUploadSuccess (serverPath, downloadPath, fileName, qualification) {
      qualification.fileName = fileName
      qualification.path = serverPath
      qualification.downloadPath = downloadPath
    },
    upload (cb, obj) {
      return async (inst) => {
        const formData = new window.FormData()
        formData.append('file', inst.file)
        formData.append('file_type', 12)
        const res = await axios.post('/management/subfinal/saveFile', formData)
        cb(res.file_path, res.file_download_path, res.file_name, obj)
      }
    },
    onBeforeUpload (file) {
      const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/png'
      if (!isIMAGE) {
        this.$message.error(this.$t('上传文件只能是图片格式'))
      }
      return isIMAGE
    },
    isVendor () {
      return this.$store.state.common.user.is_vendor
    },
    addQualification () {
      this.form.qualification.push({
        name: '',
        fileName: '',
        path: '',
        downloadPath: ''
      })
    },
    deleQualification (index) {
      this.form.qualification.splice(index, 1)
    },
    async submit () {
      await this.$refs.form.validate()
      if (!this.form.qualification[0].path) throw new Error(this.$t('请上传营业执照'))
      if (!this.form.company_logo_url) throw new Error(this.$t('请上传公司LOGO'))
      return this.form
    }
  }
}
</script>

<style lang="stylus" scoped>
.upload-area
  display flex

.uploader
  border 1px dashed #d9d9d9
  border-radius 6px
  cursor pointer
  position relative
  overflow hidden
  background #ecf7fc

.uploader:hover
  border-color #409EFF

.avatar-uploader-icon
  font-size 28px
  color #4ab7e2
  width 120px
  height 120px
  line-height 100px
  text-align center

.avatar
  width 120px
  height 120px
  display block

.upload-area__title
  font-size 12px
  margin-left 30px
  margin-right 15px

.upload__text
  position absolute
  top 62px
  left 35px
  font-size 12px
  color #4ab7e2

.qualification
  display flex

.qualificatin__title
  font-size 12px
  margin-right 10px
  margin-bottom 10px
  width 180px
</style>
